/* ==========================================================================
   Noveliya — Announcement Bar: text slideshow + dismiss
   ========================================================================== */
(function () {
  'use strict';

  var slider  = document.querySelector('.nv-ann__slider');
  var dismiss = document.getElementById('NvAnnDismiss');
  var bar     = document.getElementById('NvAnn');

  // Dismiss
  if (dismiss && bar) {
    dismiss.addEventListener('click', function () {
      bar.style.transition = 'opacity 300ms ease, max-height 400ms ease';
      bar.style.opacity    = '0';
      bar.style.maxHeight  = '0';
      bar.style.overflow   = 'hidden';
      bar.style.padding    = '0';
      setTimeout(function () { bar.remove(); }, 420);
    });
  }

  // Slideshow — only runs when there is more than one slide
  if (!slider) return;

  var slides   = Array.from(slider.querySelectorAll('.nv-ann__slide'));
  if (slides.length < 2) return;

  var interval = parseInt(slider.dataset.interval, 10) || 4000;
  var current  = 0;

  function advance() {
    var outgoing = slides[current];
    outgoing.classList.add('is-exit');
    outgoing.classList.remove('is-active');

    // Clean up exit class after transition completes
    setTimeout(function () {
      outgoing.classList.remove('is-exit');
    }, 550);

    current = (current + 1) % slides.length;
    slides[current].classList.add('is-active');
  }

  setInterval(advance, interval);
})();
